import {CurrencySign, FiatCurrencyCode} from '@raison/types';
import {BareAccount} from "./Scheme/BareAccount";
import {OperableAccount} from '~/redux/finances/domain';

export const makeBareAccount = (account: OperableAccount): BareAccount => {
    return {
        id: account.id,
        icon: account.icon,
        title: account.currencyName,
        currency: account.currencyCode as FiatCurrencyCode,
        currencySign: ((account.currencyCode as 'EUR' | 'USD') === 'EUR' ? '€' : '$') as CurrencySign,
        decimals: account.currencyDecimals,
        balance: account.balance,
        balanceIn: account.balanceIn,
        balanceOut: account.balanceOut,
    };
};
